import { useInfiniteQuery } from "@tanstack/react-query";
import { uniqBy } from "lodash-es";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/infiniteQueryUtils";
import { getChatsConversationsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useChatListQuery = (search: string) => {
	useResetInfiniteData(ChatKeys.listSearch(search));

	return useInfiniteQuery({
		queryKey: ChatKeys.listSearch(search),
		queryFn: (ctx) =>
			processResponseQuery(() =>
				getChatsConversationsV2(search || undefined, limit, ctx.pageParam),
			)(ctx),
		select: (data) =>
			uniqBy(
				data.pages.flatMap((page) => page.data),
				"id",
			),
		placeholderData: (previous) => previous,
		meta: { persist: false },
		...makeOffsetInfiniteQueryOptions(),
	});
};
